import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

export interface KnowledgeCreateFolderResponse {
  folder: Folder;
};

export interface Folder {
  id: number;
  folder_uuid: string;
  parent_folder_id: number;
  user_id: number;
  folder_name: string;
  create_time: number;
  update_time: number;
  deleted_time?: string;
};

export class KnowledgeFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;
}

class KnowledgeCreateFolderData {
  @Required("Folder cannot be empty")
  @ValidateNested(KnowledgeFolderData)
  folder: KnowledgeFolderData;
}

const transformAndValidateData = (
  response: KnowledgeCreateFolderResponse
): KnowledgeCreateFolderData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeCreateFolderData);
  } catch (error) {
    console.error("Knowledge create folder data validation failed:", error.message);
    throw error;
  }
};

/** 新建知识库文件夹 */
export const knowledgeCreateFolder = async ({
  parentFolderId,
  folderName
}: {
  parentFolderId: number,
  folderName: string
}) => {
  const res = await apiV2.post<KnowledgeCreateFolderResponse>('/knowledge/create_folder', {
    parent_folder_id: parentFolderId,
    folder_name: folderName,
  });
  const data = transformAndValidateData(res.data);
  return data;
}